import React from "react";
import { useParams } from "react-router-dom";

import CaseObservationsContent from "../../observations/components/CaseObservations";
import RecommendationsContainer from "../../recommendations/components/Recommendations";
import ViewOrAddRecommendation from "../../reporting/components/common/ViewOrAddRecommendation";
import WorkbenchTabs, { WorkbenchTab } from "./WorkbenchTabs";

const ObservationsRecommendationsPage: React.FC = () => {
  const { id: caseId } = useParams<{ id: string }>();

  if (!caseId) return null;

  const tabs: WorkbenchTab[] = [
    {
      key: "observations",
      label: "Observations",
      content: <CaseObservationsContent />,
    },
    {
      key: "recommendations",
      label: "Recommendations",
      content: (
        <>
          <RecommendationsContainer title="Main Recommendations" />
          <div className="min-w-0 overflow-x-auto">
            <ViewOrAddRecommendation caseId={caseId} />
          </div>
        </>
      ),
    },
  ];

  return (
    <WorkbenchTabs
      tabs={tabs}
      contentCardClassName="border border-gray-100 shadow-overviewCard rounded-b-xl bg-white overflow-hidden"
      contentWrapperClassName="p-4 min-w-0"
    />
  );
};

export default ObservationsRecommendationsPage;
